import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import AddCompanyPanel from "@/components/companies/AddCompanyPanel";
import { getActiveRegionConfig } from "@/lib/regionConfig";

const AddCompany = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const rawReturnTo = searchParams.get("returnTo");
  const returnTo =
    rawReturnTo && rawReturnTo.startsWith("/") && !rawReturnTo.startsWith("//")
      ? rawReturnTo
      : null;
  const regionConfig = getActiveRegionConfig();
  const goBack = () => navigate(returnTo || "/companies");

  return (
    <div data-testid="add-company-page">
      <div className="page-header">
        <Button variant="ghost" size="sm" onClick={goBack} className="mb-4">
          <ArrowLeft className="w-4 h-4 mr-2" />
          {returnTo ? "Back to Wizard" : "Back to Companies"}
        </Button>
        <h1 className="page-title">Add Company</h1>
        <p className="page-subtitle">Add company details for {regionConfig.code}</p>
      </div>

      <AddCompanyPanel
        className="max-w-2xl"
        initialTab={searchParams.get("bulk") === "true" ? "bulk" : undefined}
        onSaved={goBack}
        onCancel={goBack}
      />
    </div>
  );
};

export default AddCompany;
